export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export type TimezoneDate = {
    localUTCOffset: number;
    timezoneUTCOffset: number;
    timezoneOffset: number;
    day: number;
    month: number;
    year: number;
    hour: number;
    minute: number;
    second: number;
    dayOfWeek: DayOfWeek;
};
